import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Input, InputGroup } from 'reactstrap';
import moment from 'moment';

import { Checkbox } from 'components/Checkbox/Checkbox';
import {
  ContestNameAndDurationContainer,
  ContestNameContainer,
  ContestNameAndDurationWrapContainer,
  Label,
  DateContainer,
} from '../styles';

export default React.memo(({ updateContestDetails }) => {
  let { contest } = useSelector((state) => state.CMSEditContestReducer);

  const [contestName, setContestName] = useState(contest.name ?? '');
  const [startDate, setStartDate] = useState(moment(contest?.startDate ?? new Date()).format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment(contest?.endDate ?? new Date()).format('YYYY-MM-DD'));
  const [isHackathon, setIsHackathon] = useState(contest?.isHackathon ?? false);
  const [shortPath, setShortPath] = useState(contest?.shortPath ?? '');

  return (
    <ContestNameAndDurationContainer>
      <ContestNameAndDurationWrapContainer>
        <ContestNameContainer>
          <Label> Name:</Label>
          <InputGroup>
            <Input
              type="text"
              value={contestName}
              onChange={(e) => {
                setContestName(e.target.value);
                updateContestDetails({ name: e.target.value });
              }}
            />
          </InputGroup>
        </ContestNameContainer>
      </ContestNameAndDurationWrapContainer>
      <ContestNameAndDurationWrapContainer>
        <DateContainer padding="0 10px 0 0">
          <Label>Start date:</Label>
          <InputGroup>
            <Input
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                updateContestDetails({ startDate: e.target.value });
              }}
            />
          </InputGroup>
        </DateContainer>
        <DateContainer padding="0 0 0 10px">
          <Label>End date:</Label>
          <InputGroup>
            <Input
              type="date"
              min={startDate}
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                updateContestDetails({ endDate: e.target.value });
              }}
            />
          </InputGroup>
        </DateContainer>
      </ContestNameAndDurationWrapContainer>
      <ContestNameAndDurationWrapContainer>
        <ContestNameContainer>
          <Checkbox
            checked={isHackathon}
            onChange={() => {
              let newValue = !isHackathon;
              setIsHackathon(newValue);
              updateContestDetails({ isHackathon: newValue });
            }}
            label="Contest is hackathon"
          />
        </ContestNameContainer>
        <ContestNameContainer disableMargin>
          <Checkbox
            checked={shortPath}
            onChange={() => {
              setShortPath(shortPath ? '' : contest._id);
              updateContestDetails({ shortPath: shortPath ? '' : contest._id });
            }}
            label="Contest has short path"
          />
        </ContestNameContainer>
        {shortPath && (
          <ContestNameContainer disableMargin>
            <Label>Short path used to redirect:</Label>
            <InputGroup>
              <Input
                type="text"
                value={shortPath}
                onChange={(e) => {
                  setShortPath(e.target.value);
                  updateContestDetails({ shortPath: e.target.value });
                }}
              />
            </InputGroup>
            <Label>{`Preview: ${new URL(window.location).host}/c/${shortPath}`}</Label>
          </ContestNameContainer>
        )}
      </ContestNameAndDurationWrapContainer>
    </ContestNameAndDurationContainer>
  );
});
